/*
TODO: Handle routing with React router or similar to be able to go back in browser history
TODO: Make sure to focus on the close button to be avble to tab trough the content
*/

import React, { useEffect, forwardRef, useRef } from "react";
import Styled, { css } from "styled-components/macro";
import Button from "../../components/Button";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import { Speaker } from "../../q-components";
import RichContent from "components/RichContent/RichContent";
// import { createPrettyURI } from 'components';
import WideMedia from "../../components/WideMedia";
import { ReactComponent as Twitter } from "../../images/twitter.svg";
import { ReactComponent as Facebook } from "../../images/facebook.svg";
import { ReactComponent as LinkedIn } from "../../images/linkedin.svg";

const Header = Styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 var(--s-small);
`;

const Styles = Styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  inset: 0px;
  background-color: ${(props) =>
    props.isOpen ? "rgba(0,0,0,0.5)" : "rgba(0,0,0,0)"};
  z-index: 10;
  pointer-events: ${(props) => (props.isOpen ? "all" : "none")};
  transition: background-color var(--t-slow) var(--e-out);

  h2 {
    font: var(--f-body);
    font-size: 28px;
  }

  .sidebar__frame {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    inset: 0px;
    height: 100%;
    padding: var(--s-tiny) var(--s-small) 0 var(--s-small);
    background-color: ${(props) => `var(${props.color})`};
    color: ${(props) => `var(${props.color}--text)`};
    box-shadow: var(--s-6dp);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    transform: translate3d(100%,0,0);
    @media (min-width: 800px) {
      opacity: 0;
      transform: translate3d(30%,0,0);
    }
    @media (prefers-reduced-motion: reduce) {
      opacity: 0;
      transform: translate3d(0%,0,0);
    }

    transition: transform var(--t-base) var(--e-in), opacity var(--t-base) var(--e-in);

    ${(props) =>
      props.isOpen &&
      css`
        transform: translate3d(0, 0, 0);
        transition: transform var(--t-slow) var(--e-out),
          opacity var(--t-slow) var(--e-out);
        @media (min-width: 800px), (prefers-reduced-motion: reduce) {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }
      `}
  }


  .sidebar__button {
    color: inherit;

    &:hover {
      transform: translateX(-5px);
    }
  }
  .sidebar__content {
    flex: 1;
   max-width: 860px;
   width: 100%;
   margin: 0 auto;
    position: relative;
    padding-bottom: var(--s-medium);
    p {
      hyphens: auto;
    }

    .videoWrapper {
  width: 100%;
  margin: 32px 0;
  }
 
  }
`;

const StyledButton = Styled(Button)`
  background-color: ${(props) => `var(${props.bg}--text)`};
  border: ${(props) => `var(${props.bg}--text)`} solid 1px;
  color: ${(props) => `var(${props.color})`};
  margin: 32px 0;
  transition: all 0.5s ease; 

  &:hover {
    background-color: ${(props) => `var(${props.color})`};
    color: ${(props) => `var(${props.bg}--text)`};
    border: ${(props) => `var(${props.bg}--text)`} solid 1px;
  }
`;

const StyledHr = Styled.hr`
 background: ${(props) => `var(${props.bg}--text)`};
`;

const StyledSpeakerDescription = Styled(RichContent)`
font: var(--f-body-small);
margin-top: 15px;
`;

const SocialMedia = Styled.div`
margin-top: 30px;

div {
 display: flex;
 margin-top: 15px;
}
 
 svg {
   height: 25px;
   width: 25px;
   margin-right: 30px;
 }
`;

const NewSidebar = forwardRef((props, ref) => {
  // const closeButton = useRef(null);
  const sidebarContent = useRef(null);

  // const handleFocus = (isOpen) => {
  //   if (!ref) return;
  //   if (isOpen) ref.current.focus();
  //   console.log('ref', ref);
  // }

  // componentDidMount
  useEffect(() => {
    return () => {
      clearAllBodyScrollLocks();
    };
  }, []);

  useEffect(() => {
    if (props.open) {
      disableBodyScroll(sidebarContent.current);
      // window.history.pushState('#open', null, '#open');
    } else {
      enableBodyScroll(sidebarContent.current);
    }
  }, [props.open]);

  // let bg =
  //   type && type.includes("internally") && type.includes("externally")
  //     ? "--c-neutral--600"
  //     : type && type.includes("externally")
  //     ? "--c-neutral--900"
  //     : type && type.includes("internally")
  //     ? "--c-white"
  //     : "--c-white";

  let bg =
    props.location && props.location.includes("Grand ballroom")
      ? "--c-white"
      : props.location && props.location.includes("Belweder")
      ? "--c-neutral--300"
      : props.location && props.location.includes("Banketten")
      ? "--c-white"
      : props.location && props.location.includes("C123 (Alfa)")
      ? "--c-neutral--500"
      : props.location && props.location.includes("C123 (Beta)")
      ? "--c-neutral--600"
      : props.location && props.location.includes("C123 (Gamma)")
      ? "--c-neutral--700"
      : props.location && props.location.includes("Królewski")
      ? "--c-neutral--600"
      : "--c-neutral--600";

  return (
    <Styles
      className="sidebar__frame"
      isOpen={props.open}
      aria-hidden={!props.open}
      id={"sidebar" + props.id}
      color={bg}
    >
      <div className="sidebar__frame" ref={sidebarContent}>
        <Button
          ref={ref}
          onlyIcon
          type="button"
          aria-controls={"sidebar" + props.id}
          aria-expanded={props.open}
          className="sidebar__button sidebarCloseButton"
          onClick={props.toggleOpen}
          small
          {...props.buttonProps}
        >
          {props.closeIcon}
        </Button>
        <div className="sidebar__content">
          <Header>
            <h5>
              {props.location}
              {props.category && ` - ${props.category}`}
            </h5>
            <h4>{props.time}</h4>
          </Header>
          <h2>{props.talkTitle}</h2>
          {props.videoId && (
            <div className="videoWrapper">
              <WideMedia
                video={props.videoId ? props.videoId : false}
                poster={
                  props.videoId
                    ? props.videoPlaceholderImage && props.videoPlaceholderImage
                    : false
                }
                image={
                  props.videoId
                    ? false
                    : props.videoPlaceholderImage && props.videoPlaceholderImage
                }
                alt={props.name}
                width={props.videoPlaceholderImageWidth}
                height={props.videoPlaceholderImageHeight}
                controls
              />
            </div>
          )}

          <RichContent>{props.talkDescription}</RichContent>
          {props.typeformLink && (
            <StyledButton
              wide
              bg={bg}
              color={bg}
              href={props.typeformLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              {props.typeformLinkText}
            </StyledButton>
          )}
          <StyledHr bg={bg} />
          {props.speakers && (
            <>
              <div className="speakers">
                {props.speakers.map((speaker) => (
                  <Speaker
                    key={speaker.name}
                    name={speaker.name}
                    company={speaker.company}
                    image={speaker.image}
                    description={speaker.description}
                  />
                ))}
              </div>
              {props.speakerDescription && (
                <StyledSpeakerDescription
                  style={{
                    font: "var(--f-body-small)",
                    marginTop: "15px",
                    marginBottom: "20px",
                  }}
                >
                  {props.speakerDescription}
                </StyledSpeakerDescription>
              )}
              <SocialMedia>
                <h3>{props.shareOnSocialMedia}</h3>
                <div>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${
                      props.slug
                        ? "https://q.group/qday/?talk=" + props.slug
                        : ""
                    }`}
                  >
                    <LinkedIn color={`var(${bg}--text)`} />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://www.facebook.com/sharer/sharer.php?u=${
                      props.slug
                        ? "https://q.group/qday/?talk=" + props.slug
                        : ""
                    }`}
                  >
                    <Facebook color={`var(${bg}--text)`} />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://twitter.com/intent/tweet?url=${
                      props.slug
                        ? "https://q.group/qday/?talk=" +
                          props.slug +
                          "&text=" +
                          `Qday 2021: ${props.talkTitle}`
                        : ""
                    }`}
                  >
                    <Twitter color={`var(${bg}--text)`} />
                  </a>
                </div>
              </SocialMedia>
            </>
          )}
        </div>
      </div>
    </Styles>
  );
});

NewSidebar.defaultProps = {
  open: false,
  id: "_",
  toggleOpen: () => {
    console.error("Sidebar needs a function prop named toggleOpen");
  },
  closeIcon: "x",
  children: undefined,
  color: "--c-white",
};

export default NewSidebar;
